export const COURSES_FEATURE_KEY = 'courses';
